import { themeFor } from '../../config/theme';

// Kept for ElementPanel/FullReport, which still read `accent`. Colours live in config/theme.js.
export const elementMeta = (groupKey) => ({ accent: themeFor(groupKey).mid });
